import { render, staticRenderFns } from "./userMultiple.vue?vue&type=template&id=4235e1da&"
import script from "./userMultiple.vue?vue&type=script&lang=js&"
export * from "./userMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports